export default {
  withdraw: {
    title: '출금',
    subtitle: '빠르고 안전하며 편리하게',
    secureEncrypted: '안전하게 암호화됨',
    fiatOrCash: '법정화폐/현금',
    processing: '처리 중...',
    select: '선택',
    withdrawCurrency: '출금 통화',
    chooseNetwork: '네트워크 선택',
    channel: '채널',
    withdrawalAddress: '출금 주소',
    pixKeyType: 'PIX 키 유형',
    accountNumber: '계좌 번호',
    enterAccountNumber: '계좌 번호를 입력하세요',
    accountName: '계좌 이름',
    enterAccountName: '예금주 이름을 입력하세요',
    pixKey: 'PIX 키',
    enterPixKey: 'PIX 키를 입력하세요',
    cpf: 'CPF',
    enterCpf: 'CPF를 입력하세요',
    bankName: '은행명',
    enterBankName: '은행명을 입력하세요',
    branch: '지점',
    enterBranch: '지점을 입력하세요 (선택)',
    phone: '전화번호',
    enterPhone: '전화번호를 입력하세요 (선택)',
    email: '이메일',
    enterEmail: '이메일을 입력하세요 (선택)',
    available: '출금 가능',
    amountPlaceholder: '금액 ({unit})',
    min: '최소',
    max: '최대',
    totalWithdrawalAmount: '총 출금 금액:',
    fee: '수수료:',
    withdrawalAmount: '출금 금액:',
    fundsSafeTitle: '고객님의 자금은 안전하게 보관됩니다',
    fundsSafeDesc: '업계 최고 수준의 보안으로 거래와 개인정보를 보호합니다.',
    enterWithdrawalAddress: '출금 주소를 입력하세요',
    enterAccountNumberRequired: '계좌 번호를 입력하세요',
    selectChannelRequired: '채널을 선택해주세요',
    enterAccountNameRequired: '예금주 이름을 입력하세요',
    selectPixKeyTypeRequired: 'PIX 키 유형을 선택해주세요',
    enterCpfRequired: 'CPF를 입력하세요',
    enterValidAmount: '유효한 금액을 입력하세요',
    minWithdrawal: '최소 출금액: {amount} {unit}',
    maxWithdrawal: '최대 출금액: {amount} {unit}',
    insufficientBalance: '사용 가능 잔액이 부족합니다',
    withdrawalRejected: '출금이 거부되었습니다',
    submittedPendingReview: '출금 신청이 접수되었습니다. 검토 대기 중입니다',
    submittedPayoutInProgress: '출금 신청이 접수되었습니다. 지급 처리 중입니다',
    withdrawalFailed: '출금 실패',
    withdrawalFailedRetry: '출금에 실패했습니다. 다시 시도해주세요',
  },
};
